import { FaLinkedinIn } from 'react-icons/fa';

function Card({name = '', role = '', image = ''}) {
    return (
        <div className="group dev-card rounded overflow-y-hidden">
            
            <div className='  grayscale group-hover:grayscale-0 duration-300'>
                <img src={image ? image : ''} className=' w-full h-80 object-cover' alt='developer profile' />
            </div>
            <div className=" relative flex justify-end">
                <div className=' absolute px-6 py-4 w-fit left-0 top-0 flex justify-center items-center bg-black rounded-b'>
                    <FaLinkedinIn size={26} color='white' />
                </div>
                <div className=' w-10/12 py-10 flex justify-center items-center bg-white group-hover:bg-blue-600 group-hover:text-white duration-300 shadow-md'>
                    <div className=' flex flex-col'>
                        <span className=' text-xl font-bold'>{name ? name : "Developer Name"}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Card